import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Page from "../page";
import { Spinner } from "../../../ui";
import { useCompleteEmailSignInMutation } from "../../../data/queries/auth";
import { trackLogin } from "../../../analytics";

import style from "./style.module.scss";

function AuthCallback() {
  const navigate = useNavigate();
  const completeSignInMutation = useCompleteEmailSignInMutation();

  useEffect(() => {
    completeSignInMutation.mutate(undefined, {
      onSuccess: () => {
        trackLogin("email");
        navigate("/", { replace: true });
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (completeSignInMutation.isError) {
    return (
      <Page>
        <div className={style.container}>
          <h1 className={style.title}>Erreur de connexion</h1>
          <p className={style.message}>Le lien de connexion est invalide ou a expiré.</p>
          <p className={style.hint}>Veuillez retourner sur le site et demander un nouveau lien.</p>
          <button className={style.button} onClick={() => navigate("/", { replace: true })}>
            Retour à l'accueil
          </button>
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <div className={style.container}>
        <Spinner className={style.spinner} />
        <p className={style.message}>Connexion en cours...</p>
      </div>
    </Page>
  );
}

export default AuthCallback;
